import {
  MapPin,
  Phone,
  BankBuilding,
  ClassicBuilding,
  HouseBuilding,
  StoreBuilding,
  PieChart,
  Rocket,
  Target,
  Bones,
  Drugs,
  Brain,
  MedicalBook,
  Stethoscope,
  HeartCheckmark,
  Syringe,
  Teeth,
  Trash,
  BabyBottle,
  Pacifier,
  ToysPuzzle,
  CementCart,
  Book,
  PinLocation,
  ContractWithStamp,
  ContractWithPen,
  BabyGirl,
  HandWithHeart,
  Stomach,
  Toothbrush,
  Heartbeat,
  RoundedChats,
  WalletWithMoney,
  Suitcase,
  CupWithPenAndRuler,
  AnimalPrint,
  UserDocument,
  AGSUS,
} from 'components/icons'
import { INSTITUTION_SLUG } from 'constants/system'

const TWO_TONES_ICONS = [
  {
    value: 'Phone',
    icon: Phone,
  },
  {
    value: 'MapPin',
    icon: MapPin,
  },
  {
    value: 'BankBuilding',
    icon: BankBuilding,
  },
  {
    value: 'ClassicBuilding',
    icon: ClassicBuilding,
  },
  {
    value: 'HouseBuilding',
    icon: HouseBuilding,
  },
  {
    value: 'StoreBuilding',
    icon: StoreBuilding,
  },
  {
    value: 'PieChart',
    icon: PieChart,
  },
  {
    value: 'Rocket',
    icon: Rocket,
  },
  {
    value: 'Target',
    icon: Target,
  },
  {
    value: 'Bones',
    icon: Bones,
  },
  {
    value: 'Drugs',
    icon: Drugs,
  },
  {
    value: 'MedicalBook',
    icon: MedicalBook,
  },
  {
    value: 'Stethoscope',
    icon: Stethoscope,
  },
  {
    value: 'Syringe',
    icon: Syringe,
  },
  {
    value: 'Teeth',
    icon: Teeth,
  },
  {
    value: 'Brain',
    icon: Brain,
  },
  {
    value: 'Trash',
    icon: Trash,
  },
  {
    value: 'BabyBottle',
    icon: BabyBottle,
  },
  {
    value: 'Pacifier',
    icon: Pacifier,
  },
  {
    value: 'Book',
    icon: Book,
  },
  {
    value: 'ToysPuzzle',
    icon: ToysPuzzle,
  },
  {
    value: 'CementCart',
    icon: CementCart,
  },
  {
    value: 'PinLocation',
    icon: PinLocation,
  },
  {
    value: 'ContractWithStamp',
    icon: ContractWithStamp,
  },
  {
    value: 'ContractWithPen',
    icon: ContractWithPen,
  },
  {
    value: 'BabyGirl',
    icon: BabyGirl,
  },
  {
    value: 'HandWithHeart',
    icon: HandWithHeart,
  },
  {
    value: 'Stomach',
    icon: Stomach,
  },
  {
    value: 'Toothbrush',
    icon: Toothbrush,
  },
  {
    value: 'HeartCheckmark',
    icon: HeartCheckmark,
  },
  {
    value: 'Heartbeat',
    icon: Heartbeat,
  },
  {
    value: 'RoundedChats',
    icon: RoundedChats,
  },
  {
    value: 'WalletWithMoney',
    icon: WalletWithMoney,
  },
  {
    value: 'Suitcase',
    icon: Suitcase,
  },
  {
    value: 'CupWithPenAndRuler',
    icon: CupWithPenAndRuler,
  },
  {
    value: 'AnimalPrint',
    icon: AnimalPrint,
  },
  {
    value: 'UserDocument',
    icon: UserDocument,
  },
]

if (INSTITUTION_SLUG == 'agsus') {
  TWO_TONES_ICONS.unshift({
    value: 'AGSUS',
    icon: AGSUS,
  })
}

export default TWO_TONES_ICONS
